module.exports = __webpack_public_path__ + "static/img/loading2.9acafa3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading2.gif
// module id = 1681
// module chunks = 1